<template>
  <div class="p-3 rounded-lg shadow bg-white">
    <div class="flex items-center justify-between">
      <span
        :class="`text-${color}-500 bg-${color}-100`"
        class="w-8 h-8 rounded-lg flex grow-0 items-center justify-center"
      >
        <v-icon style="color: inherit" size="19">{{ icon }}</v-icon>
      </span>
      <router-link v-if="route" :to="route">
        <span class="text-[10px] text-blue-400">بیشتر</span>
      </router-link>
    </div>
    <h1 class="text-stone-600 mt-1 text-sm">{{ title }}</h1>
    <span class="block font-bold text-stone-500 mt-2 text-lg">{{ count }}</span>
  </div>
</template>

<script>
export default {
    props: ['icon', 'route', 'title', 'count', 'color']
};
</script>

<style lang="scss" scoped></style>
